import axios from "@/axios";

export const namespaced = true

export const state = {
    roles: [],
}

export const getters = {
    roles: (state) => state.roles
}

export const mutations = {
    SET_ROLES: (state, response) => (state.roles = response.data),
}

export const actions = {
    async getRoles({ commit }) {
        commit('SET_ROLES', await axios.get("/api/roles"))
    },
     async getPublicRoles({ commit }) {
        commit('SET_ROLES', await axios.get("/api/roles/public"))
    },
    async getUserRoles({ commit }, id) {
        commit('SET_ROLES', await axios.get(`/api/roles/user/${id}`))
    }
}
